import { Storage } from '@djs';
import { LocalStorageMethods } from './localStorageMethods';

export function initLocalStorage<State extends Record<string, any>>(initialState: State) {
  return new Storage({ methods: new LocalStorageMethods<State>(), initialState });
}
